// forms reducer
import { SET_FORMS, SET_FORMS_ERROR, SET_FORMS_LOADING } from '@/actions/types';

const initialState = {
	forms: [],
	loading: false,
	error: null,
};

export default function formsReducer(state = initialState, action) {
	switch (action.type) {
		case SET_FORMS:
			return { ...state, forms: action.payload };
		case SET_FORMS_LOADING:
			return { ...state, loading: action.payload };
		case SET_FORMS_ERROR:
			return { ...state, error: action.payload };
		default:
			return state;
	}
}
